import type { FaireBrandEntity } from "../../entity_types/brand";

export const toysmith: FaireBrandEntity = {
  token: "toysmith",
  type: "brand",
  name: "Toysmith",
  location: "Seattle, WA",
  avatarUrl:
    "https://cdn.faire.com/fastly/d70dd2bc3d53727fdd084c2d50d59a04a0a5821034f8cbf99f4eb84b634bb9a5.jpeg?bg-color=FFFFFF&canvas=192:192&dpr=1&fit=bounds&format=jpg&height=192&width=192",
  logoUrl:
    "https://cdn.faire.com/fastly/d70dd2bc3d53727fdd084c2d50d59a04a0a5821034f8cbf99f4eb84b634bb9a5.jpeg?bg-color=FFFFFF&canvas=192:192&dpr=1&fit=bounds&format=jpg&height=192&width=192",
  minimumOrderDollars: 150,
  rating: 4.8,
  isTopShop: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "parity-fix",
  },
};
